<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        :height="height" :class="classes" class="fill-current">
        <path d="M 11.951172 2 L 7.9511719 6 L 11 6 L 11 8 L 13 8 L 13 6 L 15.951172 6 L 11.951172 2 z M 3 10 C 2.448 10 2 10.448 2 11 L 2 21 C 2 21.552 2.448 22 3 22 L 21 22 C 21.552 22 22 21.552 22 21 L 22 11 C 22 10.448 21.552 10 21 10 L 3 10 z M 4.9121094 12 L 19.087891 12 A 1.5 1.5 0 0 0 20 12.912109 L 20 19.087891 A 1.5 1.5 0 0 0 19.087891 20 L 4.9121094 20 A 1.5 1.5 0 0 0 4 19.087891 L 4 12.912109 A 1.5 1.5 0 0 0 4.9121094 12 z M 12 13 A 3 3 0 0 0 9 16 A 3 3 0 0 0 12 19 A 3 3 0 0 0 15 16 A 3 3 0 0 0 12 13 z M 7 15 C 6.448 15 6 15.447 6 16 C 6 16.553 6.448 17 7 17 C 7.552 17 8 16.553 8 16 C 8 15.447 7.552 15 7 15 z M 17 15 C 16.448 15 16 15.447 16 16 C 16 16.553 16.448 17 17 17 C 17.552 17 18 16.553 18 16 C 18 15.447 17.552 15 17 15 z"/>
    </svg>
</template>

<script>
export default {
    props: [ 'height', 'classes' ]
}
</script>